import { Injectable } from '@angular/core';
import { VehicleService } from '../services/api/vehicle.service';
import { ListVehicleMastersModel } from '../model/vehicle.model';
import { CpAssignedCarModel } from '../model/cpAssignedCar.model';

export interface assinedCarGroupArray {
  employeeID: string;
  employeeName: string;
  vehicleNumber: string;
  driverName: string;
  driverNumber: string;
  carType: string;
  insuranceEndPeriod: string;
  policyEndPeriod: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppControllerService {
  assignedCarData: ListVehicleMastersModel;
  cpAssignedCarArray: CpAssignedCarModel;

  constructor(public vehicleService: VehicleService) {}
}
